import en from 'translations/en/countriesTable.json';
import pl from 'translations/pl/countriesTable.json';
import sl from 'translations/sl/countriesTable.json';
import { ITranslations } from 'types/common';
import { CountriesTableTransFields } from './types';

export const countriesTableTranslations: ITranslations<CountriesTableTransFields> = {
  name: 'countriesTable',
  en,
  pl,
  sl,
};
